export default __webpack_public_path__ + "images/d47e51881c1cdf8185e737aba53913b5-boat.webp";